"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferError = void 0;
// Deprecated in enveloped format transfer.
class TransferError extends Error {
    requestId;
    cause;
    constructor(requestId, message, cause) {
        super(message);
        this.requestId = requestId;
        this.cause = cause;
        this.name = 'TransferError';
        Object.setPrototypeOf(this, TransferError.prototype);
    }
}
exports.TransferError = TransferError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHJhbnNmZXItZXJyb3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdHJhbnNmZXItZXJyb3IudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsMkNBQTJDO0FBQzNDLE1BQWEsYUFBYyxTQUFRLEtBQUs7SUFDVjtJQUFnRTtJQUE1RixZQUE0QixTQUE2QixFQUFFLE9BQWUsRUFBa0IsS0FBZTtRQUN6RyxLQUFLLENBQUMsT0FBTyxDQUFDLENBQUE7UUFEWSxjQUFTLEdBQVQsU0FBUyxDQUFvQjtRQUFtQyxVQUFLLEdBQUwsS0FBSyxDQUFVO1FBRXpHLElBQUksQ0FBQyxJQUFJLEdBQUcsZUFBZSxDQUFBO1FBRTNCLE1BQU0sQ0FBQyxjQUFjLENBQUMsSUFBSSxFQUFFLGFBQWEsQ0FBQyxTQUFTLENBQUMsQ0FBQTtJQUN0RCxDQUFDO0NBQ0Y7QUFQRCxzQ0FPQyJ9